<h1 *ngIf="credits !== undefined">You have {{credits}} credits</h1>
<h1 *ngIf="credits === undefined">Fetching credits...</h1>

<button mat-raised-button color="primary" (click)="buy()">Buy credits</button>